import { useState, useEffect } from 'react';
import { getAllGroups } from '../../Services/Group';
import { useDispatch, useSelector } from 'react-redux';
import { Appstore } from '../../redux';
import { SetGroups } from '../../redux/catalogs/states';
import { IGroup } from '../../interfaces/models/IGroup';

let sharedGroupsRequest: Promise<IGroup[]> | null = null;

async function fetchGroupsShared (): Promise<IGroup[]> {
  if (!sharedGroupsRequest) {
    sharedGroupsRequest = getAllGroups()
      .then((data) => {
        const groups = Array.isArray(data) ? data : [];
        if (groups.length === 0) {
          sharedGroupsRequest = null;
        }
        return groups;
      })
      .catch((error) => {
        sharedGroupsRequest = null;
        throw error;
      });
  }
  return sharedGroupsRequest;
}

const UseGroupList = () => {
  const [isFetching, setIsFetching] = useState(false);

  const dispatch = useDispatch();
  const groupData = useSelector((state: Appstore) => state.groups);

  useEffect(() => {
    if (groupData.length > 0) {
      setIsFetching(false);
      return;
    }

    let cancelled = false;
    setIsFetching(true);

    fetchGroupsShared()
      .then((groups) => {
        if (!cancelled) {
          dispatch(SetGroups(groups));
        }
      })
      .catch((error) => console.error('Error fetching groups:', error))
      .finally(() => {
        if (!cancelled) {
          setIsFetching(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [groupData.length, dispatch]);

  return { groupData, isFetching };
};

export { UseGroupList };
